import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
import { findCrossings } from "./edgeCrossingUtils";
const EdgeCrossingContext = /*#__PURE__*/ createContext(null);
export function EdgeCrossingProvider({ children }) {
    const registryRef = useRef(new Map());
    const [version, setVersion] = useState(0);
    const bumpScheduledRef = useRef(false);
    const scheduleBump = useCallback(()=>{
        if (bumpScheduledRef.current) return;
        bumpScheduledRef.current = true;
        queueMicrotask(()=>{
            bumpScheduledRef.current = false;
            setVersion((v)=>v + 1);
        });
    }, []);
    const registerEdgePath = useCallback((edgeId, segments)=>{
        registryRef.current.set(edgeId, segments);
        scheduleBump();
    }, [
        scheduleBump
    ]);
    const unregisterEdgePath = useCallback((edgeId)=>{
        registryRef.current.delete(edgeId);
        scheduleBump();
    }, [
        scheduleBump
    ]);
    const getIntersections = useCallback((edgeId, segments)=>{
        const allCrossings = [];
        for (const [otherId, otherSegments] of registryRef.current){
            if (otherId === edgeId) continue;
            const hits = findCrossings(segments, otherId, otherSegments);
            allCrossings.push(...hits);
        }
        allCrossings.sort((a, b)=>a.segmentIndex - b.segmentIndex || a.t - b.t);
        return allCrossings;
    }, []);
    const ctx = useMemo(()=>({
            registerEdgePath,
            unregisterEdgePath,
            getIntersections,
            version
        }), [
        registerEdgePath,
        unregisterEdgePath,
        getIntersections,
        version
    ]);
    return /*#__PURE__*/ _jsx(EdgeCrossingContext.Provider, {
        value: ctx,
        children: children
    });
}
export function useEdgeCrossing() {
    const ctx = useContext(EdgeCrossingContext);
    if (!ctx) {
        throw new Error("useEdgeCrossing must be used within an EdgeCrossingProvider");
    }
    return ctx;
}

//# sourceMappingURL=EdgeCrossingContext.js.map